export default function NormesConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('normes');
}

NormesConfiguration.$inject = ['$translatePartialLoaderProvider'];
